function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocCampingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.007 7.01L14.269 4l-1.732 1 2.315 4.01L5.042 26H2v2h28v-2h-3.03L17.162 9.01 19.476 5l-1.732-1-1.737 3.01zM7.352 26h4.604l3.178-5.5a1 1 0 011.732 0L20.04 26h4.622l-8.654-14.99L7.352 26zm10.378 0L16 23l-1.734 3h3.464z",
    fill: props.color
  }));
}

export default SvgIconPocCampingFilled;